var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-message"},[_c('div',{staticClass:"address"},_vm._l((_vm.staticInfo.addresses),function(item){return _c('div',{key:item.id,staticClass:"address-container"},[_c('div',{staticClass:"address-pointer"}),_c('div',[_vm._v(_vm._s(item.append))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }